(function () {
    const headerLocationText = document.getElementById('header-geo-location-text');
    const headerLocationLink = document.getElementById('header-geo-location-link');

    if (!headerLocationText || !headerLocationLink) return;

    function openGeoSelectorFromHeader() {
        if (typeof window.openGeoLocationSelector === 'function') {
            window.openGeoLocationSelector();
            return true;
        }

        // Defensive fallback if global opener is not yet initialized.
        const selector = document.getElementById('geo-location-selector');
        if (selector) {
            selector.style.display = 'flex';
            document.body.style.overflow = 'hidden';
            return true;
        }

        return false;
    }

    function handleHeaderGeoLocationClick(event) {
        if (event && typeof event.preventDefault === 'function') {
            event.preventDefault();
        }

        if (openGeoSelectorFromHeader()) {
            return false;
        }

        // In case selector script initialized late, retry briefly before giving up.
        let attempts = 0;
        const maxAttempts = 8;
        const interval = setInterval(() => {
            attempts += 1;
            if (openGeoSelectorFromHeader() || attempts >= maxAttempts) {
                clearInterval(interval);
            }
        }, 100);

        return false;
    }

    window.handleHeaderGeoLocationClick = handleHeaderGeoLocationClick;
    headerLocationLink.addEventListener('click', handleHeaderGeoLocationClick);

    /**
     * Truncate text to maximum 21 characters
     */
    function truncateText(text, maxLength = 21) {
        if (!text || text.length <= maxLength) return text;
        return text.substring(0, maxLength - 3) + '...';
    }

    /**
     * Format address to show only: street, sector/residential, country
     */
    function formatAddressSimple(addressString) {
        if (!addressString || addressString.trim() === '' || addressString.trim() === 'via unnamed roads') {
            return null;
        }

        // Split address by commas
        const parts = addressString
            .split(',')
            .map((part) => part.trim())
            .filter((part) => part !== '');

        if (parts.length === 0) {
            return null;
        }

        // Extract components
        let street = '';
        let sector = '';
        let country = '';

        // First part is usually the street
        if (parts.length > 0) {
            street = parts[0];
            // If it's "unnamed road" or similar, use that
            if (street.toLowerCase().includes('unnamed')) {
                street = 'Via unnamed roads';
            }
        }

        // Look for sector/residential (usually in the middle parts)
        for (let i = 1; i < parts.length - 1; i++) {
            const part = parts[i];
            // Skip postal codes (numbers)
            if (!/^\d+$/.test(part)) {
                // Look for residential/sector indicators
                if (
                    part.toLowerCase().includes('ciudad') ||
                    part.toLowerCase().includes('residencial') ||
                    part.toLowerCase().includes('sector') ||
                    part.toLowerCase().includes('santo domingo') ||
                    part.toLowerCase().includes('barrio') ||
                    part.toLowerCase().includes('villa')
                ) {
                    sector = part;
                    break;
                }
            }
        }

        // Last part is usually country
        if (parts.length > 1) {
            const lastPart = parts[parts.length - 1];
            // If it's a country name (not a postal code)
            if (!/^\d+$/.test(lastPart) && lastPart.length > 3) {
                country = lastPart;
            } else if (parts.length > 2) {
                // Try second to last if last is postal code
                country = parts[parts.length - 2];
            }
        }

        // Build formatted address
        const formattedParts = [];
        if (street) formattedParts.push(street);
        if (sector) formattedParts.push(sector);
        if (country) formattedParts.push(country);

        return formattedParts.length > 0 ? formattedParts.join(', ') : null;
    }

    /**
     * Calculate distance between two coordinates (Haversine formula)
     * Returns distance in miles
     */
    function calculateDistance(lat1, lng1, lat2, lng2) {
        const R = 3959; // Earth's radius in miles
        const toRad = (deg) => (deg * Math.PI) / 180;
        const dLat = toRad(lat2 - lat1);
        const dLng = toRad(lng2 - lng1);

        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);

        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
    }

    /**
     * Check if user is near pickup stores and return store name
     * Returns 'hartville', 'middlefield', or null
     */
    function checkNearbyStore(location) {
        if (!location || !location.lat || !location.lng) {
            return null;
        }

        // Check if stores data is available
        if (!window.geoStores || !Array.isArray(window.geoStores) || window.geoStores.length === 0) {
            return null;
        }

        const nearbyPickupStores = [];

        // Check each store
        window.geoStores.forEach((store) => {
            if (!store.latitude || !store.longitude) return;

            const storeLat = parseFloat(store.latitude);
            const storeLng = parseFloat(store.longitude);
            const radius = store.radius || 50; // Default 50 miles

            const distance = calculateDistance(location.lat, location.lng, storeLat, storeLng);

            if (distance <= radius) {
                const storeName = (store.name || '').toLowerCase();
                if (storeName.includes('hartville')) {
                    nearbyPickupStores.push({ key: 'hartville', distance });
                } else if (storeName.includes('middlefield')) {
                    nearbyPickupStores.push({ key: 'middlefield', distance });
                }
            }
        });

        if (!nearbyPickupStores.length) return null;

        nearbyPickupStores.sort((a, b) => a.distance - b.distance);

        // Tie-breaker: if effectively tied, keep Hartville priority to match previous behavior.
        const best = nearbyPickupStores[0];
        const second = nearbyPickupStores[1];
        const hartvillePreferenceMiles = getHartvillePreferenceMiles();
        if (second && Math.abs(second.distance - best.distance) <= hartvillePreferenceMiles) {
            return nearbyPickupStores.some((s) => s.key === 'hartville') ? 'hartville' : best.key;
        }

        return best.key;
    }

    function getHartvillePreferenceMiles() {
        const configured = parseFloat(window?.geoLocationConfig?.hartvillePreferenceMiles);
        if (Number.isFinite(configured) && configured >= 0) return configured;
        return 0.25;
    }

    function normalizeStoreKey(value) {
        if (!value) return '';
        const normalized = String(value).toLowerCase().trim();
        if (normalized.includes('hartville')) return 'hartville';
        if (normalized.includes('middlefield')) return 'middlefield';
        if (
            normalized.includes('shop') ||
            normalized.includes('online') ||
            normalized.includes('warehouse') ||
            normalized.includes('shipping') ||
            normalized.includes('ecom') ||
            normalized.includes('e-commerce') ||
            normalized.includes('main store') ||
            normalized.includes('main')
        ) return 'shop';
        return normalized;
    }

    function getExplicitAssignedStoreKey() {
        try {
            const stored = localStorage.getItem('geo_assigned_store');
            if (!stored) return '';
            const parsed = JSON.parse(stored);
            const key = normalizeStoreKey(parsed?.key);
            if (key === 'hartville' || key === 'middlefield' || key === 'shop') return key;
        } catch (e) {
            // ignore
        }
        return '';
    }

    function normalizeStoreKey(value) {
        if (!value) return '';
        const normalized = String(value).toLowerCase().trim();
        if (normalized.includes('hartville')) return 'hartville';
        if (normalized.includes('middlefield')) return 'middlefield';
        if (
            normalized.includes('shop') ||
            normalized.includes('online') ||
            normalized.includes('warehouse') ||
            normalized.includes('shipping') ||
            normalized.includes('ecom') ||
            normalized.includes('e-commerce') ||
            normalized.includes('main store') ||
            normalized.includes('main')
        ) return 'shop';
        return normalized;
    }

    function getExplicitAssignedStoreKey() {
        try {
            const stored = localStorage.getItem('geo_assigned_store');
            if (!stored) return '';
            const parsed = JSON.parse(stored);
            const key = normalizeStoreKey(parsed?.key);
            if (key === 'hartville' || key === 'middlefield' || key === 'shop') return key;
        } catch (e) {
            // ignore
        }
        return '';
    }

    function updateHeaderLocationText() {
        const headerLocationBody = document.getElementById('header-geo-location-body');

        // Default: show "Find a Store Near You" and hide location body
        headerLocationText.textContent = 'Find a Store Near You';
        headerLocationLink.title = 'Find a Store Near You';
        if (headerLocationBody) {
            document.querySelector('.header-content-icon--location-path').style.fill = 'transparent';
            headerLocationBody.style.display = 'none';
        }

        // Read location directly from localStorage to avoid cache issues
        let location = null;

        // Check for manual override first
        const overrideStr = localStorage.getItem('geo_location_override');
        if (overrideStr) {
            try {
                location = JSON.parse(overrideStr);
            } catch (e) {
                // Invalid override, continue to regular location
            }
        }

        // If no override, check regular location
        if (!location || !location.lat || !location.lng) {
            const locationStr = localStorage.getItem('geo_user_location');
            if (locationStr) {
                try {
                    location = JSON.parse(locationStr);
                } catch (e) {
                    // Invalid location, continue to service fallback
                }
            }
        }

        // Fallback to service if available and no location in localStorage
        if ((!location || !location.lat || !location.lng) && window.geoLocationService) {
            location = window.geoLocationService.getCurrentLocation();
        }

        // Explicit assigned store choice takes precedence over radius display.
        const explicitAssignedStoreKey = getExplicitAssignedStoreKey();
        if (explicitAssignedStoreKey === 'shop') {
            return;
        }
        if (explicitAssignedStoreKey === 'hartville') {
            headerLocationText.textContent = 'Hartville';
            headerLocationLink.title = 'Hartville';
            if (headerLocationBody) {
                document.querySelector('.header-content-icon--location-path').style.fill = '#b21f27';
                headerLocationBody.style.display = '';
            }
            return;
        }
        if (explicitAssignedStoreKey === 'middlefield') {
            headerLocationText.textContent = 'Middlefield';
            headerLocationLink.title = 'Middlefield';
            if (headerLocationBody) {
                document.querySelector('.header-content-icon--location-path').style.fill = '#b21f27';
                headerLocationBody.style.display = '';
            }
            return;
        }

        const nearbyStore = checkNearbyStore(location);
        if (nearbyStore === 'hartville' || nearbyStore === 'middlefield') {
            headerLocationText.textContent = nearbyStore === 'hartville' ? 'Hartville' : 'Middlefield';
            headerLocationLink.title = headerLocationText.textContent;
            if (headerLocationBody) {
                document.querySelector('.header-content-icon--location-path').style.fill = '#b21f27';
                headerLocationBody.style.display = '';
            }
        }

    }

    // Update on location changes (event from geo-location service)
    document.addEventListener('geo:location-updated', updateHeaderLocationText);

    // Update on location changes (legacy event)
    document.addEventListener('geo-location-updated', updateHeaderLocationText);

    // Update on location changes (same-tab localStorage changes)
    window.addEventListener('localStorage-geo-updated', updateHeaderLocationText);

    // Update on location changes (cross-tab localStorage changes)
    window.addEventListener('storage', (e) => {
        if (
            e.key === 'geo-location-data' ||
            e.key === 'geo_user_location' ||
            e.key === 'geo_assigned_store' ||
            e.key === 'geo_location_override'
        ) {
            updateHeaderLocationText();
        }
    });

    // Initial update: run immediately to avoid default-icon flash,
    // then run a short follow-up in case geo/storage initializes just after load.
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            updateHeaderLocationText();
            setTimeout(updateHeaderLocationText, 150);
        });
    } else {
        updateHeaderLocationText();
        setTimeout(updateHeaderLocationText, 150);
    }
})();